import { message, Modal, Segmented, Spin } from "antd";
import { Col, Row } from "react-bootstrap";
import { StyledTable } from "atoms/Table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { ReactComponent as Dateicon } from "../../assets/icons/Vector.svg";
import dayjs from "dayjs";
import COLORS from "common/Colors";
import { useSelector } from "react-redux";
import { getLocations, getUserList, getCountryTimezone } from "redux/selectors";
import { RightOutlined } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { getLatestReviewedAt, isReEnabledAfterCycleClosed } from "./cycleRules";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import CreateEditPerformance from "./CreateEditPerformance";
import AppraisalHistory from "./AppraisalHistory";
import axios from "axios";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import user from "../../assets/employeeinfo.svg";
import { EmployeeInfo } from "./EmployeeInfo";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(timezone);
dayjs.extend(utc);

const StyledDiv = styled.div`
  .wrapped-header {
    white-space: normal !important;
  }
  .cursor-pointer {
    cursor: pointer;
  }

  .Appraisal_first_tabledata {
    display: flex;
    gap: 10px;
  }
`;

const SegmentWrap = styled(Segmented)`
  position: sticky;
  top: 0px;
  float: right;
  background-color: #fff;
  z-index: 100;
  border: 1px solid #ffffff;
  color: #636980;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  .ant-segmented-item-selected {
    background-color: #00685F !important;
    color: white;
  }
`;

const StyledCloseButton = styled(ButtonFilled)`
  &&& {
    background-color: #DEEFEE !important;
    color: #000000 !important;
    
    span {
      color: #000000 !important;
    }
  }
`;

const ViewContract = () => {
  const CountryTimezone = useSelector(getCountryTimezone);
  const locationList = useSelector(getLocations);
  const history = useHistory();
  const location = useLocation();
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const appraisalRecord = history?.location?.state?.appraisalRecord || {};
  const userList = useSelector((state) => getUserList(state)) || [];
  const userInfo = useSelector((state) => state?.user?.userInfo) || {};

  const [allAppraisalData, setAllAppraisalData] = useState([]);
  const [appraisalDetails, setAppraisalDetails] = useState({});
  const [segmentedData, setSegmentData] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [softSkillData, setSoftSkillData] = useState([]);
  const [technicalAssessmentData, setTechnicalAssessmentData] = useState([]);
  const [rolledOverData, setRolledoverData] = useState([]);
  const [upcomingData, setUpcomingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selecteduserRecord, setSelectedUserRecord] = useState({});
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const getData = async () => {
    const { code, response, performanceContractList } = await CALL_API(
      `appraisal/history?appraiseemailid=${history?.location?.state?.appraisalRecord?.userid}`,
      "get",
      {}
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setHistoryData(performanceContractList);
    }
  };

  const transformStrategicObjectives = (data) => {
    return data?.map((item, index) => ({
      key: `strategic-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item?.straobjorgstartegy || "-",
      ExpectedOutcomes: item?.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformRolloverResponsibility = (data) => {
    return data?.map((item, index) => ({
      key: `rollover-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.previousappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate,
      // ? dayjs(item.TargetDate).format("DD-MM-YYYY")
      // : "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const transformUpcomingAppraisal = (data) => {
    return data?.map((item, index) => ({
      key: `upcoming-${index + 1}`,
      Slno: index + 1,
      Targetobjectives: item.upcomingappraisalperiod || "-",
      ExpectedOutcomes: item.expectedoutcome || "-",
      TargetDate: item?.TargetDate || "-",
      Weightage: item.Weightage || "-",
    }));
  };

  const dataColumns = [
    {
      title: "Objectives",
      dataIndex: "objective",
      key: "objective",
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
    },
  ];

  const getColumns = (objectiveTitle) => [
    {
      title: "S.No",
      dataIndex: "Slno",
      key: "Slno",
    },
    {
      title: objectiveTitle,
      dataIndex: "Targetobjectives",
      key: "Targetobjectives",
      className: "wrapped-header",
    },
    {
      title: "Expected Outcomes",
      dataIndex: "ExpectedOutcomes",
      key: "ExpectedOutcomes",
      className: "wrapped-header",
    },
    {
      title: "Target Date",
      dataIndex: "TargetDate",
      key: "TargetDate",
      render: (text) => (
        <>
          <Dateicon style={{ marginRight: "10px" }} />
          {moment(text).format("DD-MM-YYYY")}
        </>
      ),
    },
    {
      title: "Weightage",
      dataIndex: "Weightage",
      key: "Weightage",
    },
  ];

  const handleCancelModal = () => setIsModalVisible(false);

  const getDetails = async () => {
    setLoading(true);
    const { code, performanceContractList } = await CALL_API(
      `appraisal/appraiseemine?userid=${appraisalRecord?.userid}`,
      "get",
      {}
    );

    // Roster change-log (Postgres, always fresh) — needed to tell a role that
    // was DELETED-then-RE-ADDED after this cycle closed apart from one that
    // genuinely belongs to it. The live roster alone can't: a re-added role is
    // active again, so it passes the liveRoster filter and — because it's still
    // frozen into this cycle's contract snapshot — renders a blank placeholder
    // tab for a role that never had a contract here. See cycleRules.
    let rosterHistoryList = [];
    try {
      const historyRes = await CALL_API(
        `appraisal/appraisalhisorty?userid=${appraisalRecord?.userid}`,
        "get",
        {}
      );
      rosterHistoryList = historyRes?.historyList || [];
    } catch (e) {
      rosterHistoryList = [];
    }

    if (code === STATUS_CODE?.SUCCESS) {
      // ✅ Fix 1: Remove appraiserid filter — API is already scoped to userid
      setAllAppraisalData(performanceContractList);

      // ✅ Fix 2: Filter by contractid first (exact match for clicked record)
      const exactMatch = performanceContractList?.filter(
        (item) => item?.contractid === appraisalRecord?.contractid
      );

      // ✅ Fix 3: Then get all contracts with same performanceid for segments
      const targetPerformanceid = exactMatch?.[0]?.performanceid
        ?? appraisalRecord?.performanceid;

      const filtered = performanceContractList?.filter(
        (item) => item?.performanceid === targetPerformanceid
      );

      // Scenario 1: cycle still ongoing (some configured role not yet
      // created/reviewed) -> show every configured role's tab, including
      // empty placeholders, so testers can see what's still pending.
      // Scenario 2: cycle fully closed (every configured role reviewed) ->
      // show only tabs for roles that actually exist here, no placeholders.
      //
      // Roster is read from the cycle's OWN contract snapshot
      // (appraisalinformation, frozen at contract-creation time), not today's
      // live config — a role added after this cycle already closed must not
      // retroactively show up here just because it's active today.
      const clickedRoleSnapshot = exactMatch?.[0]?.appraisalinformation;
      const cycleRoleSnapshot =
        Array.isArray(clickedRoleSnapshot) && clickedRoleSnapshot.length > 0
          ? clickedRoleSnapshot
          : filtered?.find(
            (item) =>
              Array.isArray(item?.appraisalinformation) &&
              item.appraisalinformation.length > 0
          )?.appraisalinformation;

      const liveRoster =
        userList?.find((item) => item?.userid === appraisalRecord?.userid)
          ?.appraisalInformation || [];
      // A role toggled to "No" (or deleted) after this cycle's contract was
      // created must not keep showing a pending placeholder — it's been
      // actively turned off, not just "not yet created".
      const liveYesRoleTypes = new Set(
        liveRoster
          .filter((role) => role?.appraisal === "Yes")
          .map((role) => (role?.roletype || "").trim().toLowerCase())
      );

      // The cohort locks when the cycle is DONE, not at its first review. While
      // any contract here is still unreviewed the cycle is running, so a role
      // added now legitimately belongs to it — read the live roster. Once every
      // contract is reviewed the cycle is settled and the frozen snapshot takes
      // over, so later roster edits can't rewrite a closed cycle.
      const cycleFullyReviewed =
        filtered?.length > 0 &&
        filtered.every((c) => c?.contractstatus === "reviewed");

      // When the cycle is closed we still can't rely on the frozen snapshot
      // ALONE: a role added mid-cycle that never got a contract is absent from
      // the snapshot, so it would never even be considered for a tab. Union the
      // snapshot with the live roster (snapshot first, live roles appended if not
      // already present) so such a role is evaluated; the filter below then keeps
      // it only if it isn't a genuine after-close re-add. While the cycle is open
      // the live roster already covers everything.
      const rosterSource =
        cycleFullyReviewed &&
          Array.isArray(cycleRoleSnapshot) &&
          cycleRoleSnapshot.length > 0
          ? (() => {
            const byType = new Map();
            cycleRoleSnapshot.forEach((r) =>
              byType.set((r?.roletype || "").trim().toLowerCase(), r)
            );
            (liveRoster || []).forEach((r) => {
              const k = (r?.roletype || "").trim().toLowerCase();
              if (!byType.has(k)) byType.set(k, r);
            });
            return [...byType.values()];
          })()
          : liveRoster;

      // Cutoff for "re-added after the cycle closed". A role deleted and added
      // back after the cycle finished is a fresh joiner for a LATER cycle, not a
      // pending member here, so it must not render a blank placeholder tab.
      //
      // Only meaningful once the cycle is GENUINELY closed. `filtered` covers
      // only the contracts that EXIST in this cycle, so "every reviewed" is true
      // even when a cohort role never reached this cycle. A genuine laggard — a
      // live "Yes" role with no contract here that was NEVER deleted (so it's
      // been continuously present, just hasn't caught up) — means the cycle is
      // still running. Using one finished sibling's review time as the cutoff
      // then wrongly hides a churned laggard (a real member deleted + re-added
      // while still owing this cycle). Only the delete history separates that
      // laggard from a true after-close re-add.
      const hasGenuineLaggardHere = (liveRoster || []).some((role) => {
        if (role?.appraisal !== "Yes") return false;
        const rt = (role?.roletype || "").trim().toLowerCase();
        const hasContractHere = filtered?.some(
          (c) => (c?.roletype || "").trim().toLowerCase() === rt
        );
        if (hasContractHere) return false;
        const wasEverDeleted = (rosterHistoryList || []).some(
          (h) =>
            (h?.roletype || "").trim().toLowerCase() === rt &&
            h?.change === "Row deleted"
        );
        return !wasEverDeleted;
      });
      const cycleReviewedAt =
        cycleFullyReviewed && !hasGenuineLaggardHere
          ? getLatestReviewedAt(filtered)
          : 0;

      const employeeRoleTypes = (rosterSource || []).filter((role) => {
        const roleType = role?.roletype;
        const hasContractHere = filtered?.some(
          (item) =>
            item?.roletype?.trim().toLowerCase() ===
            (roleType || "").trim().toLowerCase()
        );
        // A role with an actual contract in this cycle always shows — it
        // genuinely participated (§12A.1 rule 1: hasContractHere wins), even if
        // it was later removed from the live roster.
        if (hasContractHere) return true;
        // No contract here: it only belongs if it's still an active roster role.
        if (
          role?.appraisal !== "Yes" ||
          !liveYesRoleTypes.has((roleType || "").trim().toLowerCase())
        ) {
          return false;
        }
        // Active but contract-less: drop it only if it was re-added AFTER the
        // cycle closed (a next-cycle joiner). A role added mid-cycle sits before
        // the last review, so it survives and shows as a pending placeholder.
        if (
          isReEnabledAfterCycleClosed(rosterHistoryList, roleType, cycleReviewedAt)
        ) {
          return false;
        }
        return true;
      });

      // An older cycle (already superseded by a later one) is always treated
      // as closed regardless of role completeness — a role missing from an
      // old cycle didn't participate, it isn't "still pending".
      const globalMaxPid = performanceContractList?.reduce(
        (max, c) => Math.max(max, Number(c?.performanceid) || 0),
        0
      );
      const isLatestCycle = Number(targetPerformanceid) === globalMaxPid;

      const isCycleClosed =
        !isLatestCycle ||
        (employeeRoleTypes?.length > 0 &&
          employeeRoleTypes.every((role) =>
            filtered?.some(
              (item) =>
                item?.roletype?.trim().toLowerCase() ===
                role?.roletype?.trim().toLowerCase() &&
                item?.contractstatus === "reviewed"
            )
          ));

      const missingRoleTypes = employeeRoleTypes?.filter(
        (role) =>
          !filtered?.some(
            (item) =>
              item?.roletype?.trim().toLowerCase() ===
              role?.roletype?.trim().toLowerCase()
          )
      );

      const segmentedData = isCycleClosed
        ? filtered?.map((item) => ({
          roletype: item?.roletype,
          contractid: item?.contractid,
        })) || []
        : [
          ...(filtered?.map((item) => ({
            roletype: item?.roletype,
            contractid: item?.contractid,
          })) || []),
          ...(missingRoleTypes?.map((role) => ({
            roletype: role?.roletype,
            contractid: undefined,
          })) || []),
        ];

      const sortedSegmentedData = [...segmentedData].sort((a, b) => {
        if (a.roletype === appraisalRecord.roletype) return -1;
        if (b.roletype === appraisalRecord.roletype) return 1;

        const roleA = a.roletype?.toLowerCase() || "";
        const roleB = b.roletype?.toLowerCase() || "";

        if (roleA === "primary" && roleB !== "primary") return -1;
        if (roleB === "primary" && roleA !== "primary") return 1;

        const numberA = parseInt(roleA.match(/\d+/)?.[0], 10) || 0;
        const numberB = parseInt(roleB.match(/\d+/)?.[0], 10) || 0;

        return numberA - numberB;
      });

      setSegmentData(sortedSegmentedData);
      setSelectedSegment(sortedSegmentedData[0]?.roletype);

      // ✅ Fix 5: Always set selectedEmployee regardless of filter result
      setSelectedEmployee(
        userList?.find((item) => item?.userid === appraisalRecord?.userid)
      );

      setLoading(false);
    }
  };

  const showModal = () => setIsModalVisible(true);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    getDetails();
    getData();
  }, [appraisalRecord, isAddEdit]);

  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);

  const findtimeZone = CountryTimezone?.filter(
    (item) => item?.country === finduser?.managingoffice[0]
  );

  const jobDescriptionDetails = userList
    ?.find((val) => val?.userid === appraisalDetails?.apraiseemailid)
    ?.appraisalInformation?.filter(
      (item) => item?.roletype === appraisalDetails?.roletype
    );

  // useEffect(() => {
  //   setAllAppraisalData(appraisalRecord);

  //   const segmentedData = appraisalRecord?.map((item) => {
  //     return {
  //       roletype: item?.appraisalInformation[0]?.roletype,
  //       contractid: item.contractid,
  //     };
  //   });

  //   const sortedSegmentedData = [...segmentedData].sort((a, b) => {
  //     const roleA = a.roletype.toLowerCase();
  //     const roleB = b.roletype.toLowerCase();

  //     if (roleA === "primary") return -1;
  //     if (roleB === "primary") return 1;

  //     const numberA = parseInt(roleA.match(/\d+/)?.[0], 10) || 0;
  //     const numberB = parseInt(roleB.match(/\d+/)?.[0], 10) || 0;

  //     return numberA - numberB;
  //   });

  //   setSelectedSegment(segmentedData[0]?.contractid);
  // }, [appraisalRecord]);

  useEffect(() => {
    const currentTabContractId = segmentedData?.find(
      (item) => item?.roletype === selectedSegment
    )?.contractid;

    const filtered = allAppraisalData?.filter(
      (item) => item?.contractid === currentTabContractId
    );
    setAppraisalDetails(filtered[0] || {});
    setSoftSkillData(
      filtered[0]?.softskills?.map((item, index) => {
        return { ...item, id: index + 1 };
      })
    );
    setTechnicalAssessmentData(
      transformStrategicObjectives(filtered[0]?.startegicobjectives)
    );
    setRolledoverData(
      transformRolloverResponsibility(filtered[0]?.rolloverresponsibility)
    );
    setUpcomingData(
      transformUpcomingAppraisal(filtered[0]?.upcomingappraisalperiod)
    );
  }, [selectedSegment, allAppraisalData, segmentedData]);

  const WorkInfoDetails = [
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    {
      data: "Name of the employee",
      value: appraisalRecord?.fullname || "-",
    },
    {
      data: "Period",
      value: appraisalDetails?.period || "-",
    },
    {
      data: "Start date to attend appraisal",
      value: appraisalDetails?.attendstartdate
        ? moment(appraisalDetails?.attendstartdate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "End date to attend appraisal",
      value: appraisalDetails?.attendenddate
        ? moment(appraisalDetails?.attendenddate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Employee ID",
      value: appraisalRecord?.employeeid || "-",
    },
    {
      data: "Managing Office",
      value:
        typeof appraisalRecord?.managingoffice === "string"
          ? appraisalRecord?.managingoffice
            ? [appraisalRecord?.managingoffice]
            : "-"
          : appraisalRecord?.managingoffice?.join(", ") || "-",
    },
    {
      data: "Grade",
      value: appraisalRecord?.grade || "-",
    },
    {
      data: "Location",
      value:
        locationList?.find(
          (item) => item.location_id === appraisalRecord?.levellocationid
        )?.location_name || "-",
    },
    {
      data: "Department",
      value: appraisalRecord?.leveldepartmentname || "-",
    },
    {
      data: "Contracting Company",
      value: appraisalRecord?.companyname || "-",
    },
    {
      data: "Designation",
      value: appraisalRecord?.designation || "-",
    },

    {
      data: "Hired Date",
      value: appraisalRecord?.hireddate
        ? moment(appraisalRecord?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Professional Since",
      value: appraisalRecord?.professionalsince
        ? moment(appraisalRecord?.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Target Chargeability %",
      value: appraisalRecord?.targetchargeability || "-",
    },
    {
      data: "Charge Out Rate",
      value: appraisalRecord?.chargeoutrate || "-",
    },
    {
      data: "Last Promotion Date",
      value: appraisalRecord?.lastpromotionlevel
        ? moment(appraisalRecord?.lastpromotionlevel).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Last Promotional Level",
      value: appraisalRecord?.lastpromotion
        ? appraisalRecord?.lastpromotion
        : "-",
    },
  ];

  const mergedHistoryData = historyData
    ?.filter(
      (item) =>
        item.contractid === appraisalDetails?.contractid &&
        item.contractstatus !== "draft"
    )
    ?.reduce((acc, item) => {
      Object.entries(item).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
      });
      return acc;
    }, {});
  let historydate = mergedHistoryData?.createdat;

  const contractStatus = appraisalDetails?.contractstatus;
  if (
    contractStatus === "created" ||
    contractStatus === "resend" ||
    contractStatus === "updated"
  ) {
    historydate = mergedHistoryData?.createdat;
  } else if (contractStatus === "accepted") {
    historydate = mergedHistoryData?.accepteddeclinedon;
  } else if (contractStatus === "declined") {
    historydate = mergedHistoryData?.accepteddeclinedon;
  } else if (contractStatus === "attended") {
    historydate = mergedHistoryData?.attendedon;
  } else if (contractStatus === "reviewed") {
    historydate = mergedHistoryData?.reviewedon;
  }
  let dateLabel = "Accepted on: -";
  if (
    contractStatus === "created" ||
    contractStatus === "resend" ||
    contractStatus === "updated"
  ) {
    dateLabel = dayjs(historydate).isValid()
      ? `Created on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Created on: -";
  } else if (contractStatus === "accepted") {
    dateLabel = dayjs(historydate).isValid()
      ? `Accepted on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Accepted on: -";
  } else if (contractStatus === "declined") {
    dateLabel = dayjs(historydate).isValid()
      ? `Declined on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Declined on: -";
  } else if (contractStatus === "attended") {
    dateLabel = dayjs(historydate).isValid()
      ? `Attended on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Attended on: -";
  } else if (contractStatus === "reviewed") {
    dateLabel = dayjs(historydate).isValid()
      ? `Reviewed on: ${dayjs(historydate).format("D MMM YYYY, hh:mm A")}`
      : "Reviewed on: -";
  }
  const personalDet = [
    {
      data: "Salutation",
      value: appraisalRecord?.salutation || "-",
    },

    {
      data: "Date Of Birth",
      value: appraisalRecord?.dateofbirth ? appraisalRecord?.dateofbirth : "-",
    },
    {
      data: "Gender",
      value: appraisalRecord?.gender
        ? appraisalRecord?.gender.charAt(0).toUpperCase() +
        appraisalRecord?.gender.slice(1)
        : "-",
    },
    {
      data: "Marital Status",
      value: appraisalRecord?.maritalstatus
        ? appraisalRecord?.maritalstatus.charAt(0).toUpperCase() +
        appraisalRecord?.maritalstatus.slice(1)
        : "-",
    },
    {
      data: "No. of Dependants",
      value: appraisalRecord?.dependent || "-",
    },
    {
      data: "Greetings",
      value: appraisalRecord?.greetings || "-",
    },

    {
      data: "Phone No",
      value: appraisalRecord?.phoneno || "-",
    },
    {
      data: "Email Address",
      value: appraisalRecord?.userid || "-",
    },
    {
      data: "Postal Address",
      value: appraisalRecord?.postaladdress || "-",
    },

    {
      data: "Emergency Contact Name",
      value: appraisalRecord?.emergencycontactname || "-",
    },
    {
      data: "Emergency Contact Number",
      value: appraisalRecord?.emergencycontactnumber || "-",
    },
  ];

  const showDeleteConfirmation = () => {
    Modal.confirm({
      title: "Are you sure you want to delete this performance contract?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      okButtonProps: {
        style: {
          backgroundColor: "#c2fae5",
          color: "black",
        },
      },
      async onOk() {
        try {
          setLoading(true);
          const { code } = await CALL_API(
            `appraisal/${appraisalRecord?.contractid}`,
            "delete"
          );
          if (code === STATUS_CODE.SUCCESS) {
            history.push("/performancemanagement");
          }
        } catch (err) {
          console.error("[deleteContract] -->", err);
        } finally {
          setLoading(false);
        }
      },
      onCancel() { },
    });
  };

  const viewJobDescription = async () => {
    if (
      !jobDescriptionDetails[0]?.jobDescriptionId ||
      !jobDescriptionDetails[0]?.jobdescriptionFileName
    ) {
      message.warning("User has not created a Job Description.");
      return;
    }
    const token = window.localStorage.getItem("token") || "";
    try {
      setLoader(true);
      const response = await axios.get(
        "https://axcxv4d066.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: jobDescriptionDetails[0]?.jobDescriptionId,
            filename: jobDescriptionDetails[0]?.jobdescriptionFileName,
          },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        setPdfUrl(response.data.url);
        setIsPdfModalOpen(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
        setLoader(false);
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  return (
    <StyledDiv>
      <Spin spinning={loader}>
        <Modal
          open={isPdfModalOpen}
          onCancel={() => setIsPdfModalOpen(false)}
          footer={null}
          width={1000}
          centered
          bodyStyle={{ height: "80vh", padding: 0 }}
        >
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <p style={{ textAlign: "center", paddingTop: "40%" }}>Loading...</p>
          )}
        </Modal>
        {!isAddEdit && (
          <div>
            <SegmentWrap
              options={segmentedData.map((item) => ({
                label: item?.roletype,
                value: item?.roletype,
              }))}
              value={selectedSegment}
              onChange={(value) => {
                setSelectedSegment(value);
              }}
            />

            <div className="Appraisal_first_tabledata">
              <span
                className="cursor-pointer"
                onClick={() =>
                  history.push({
                    pathname: "/performancemanagement",
                    state: {
                      tabId: "managerappraisal",
                      selectedItem: "performance-contract",
                    },
                  })
                }
              >
                Performance Management
              </span>{" "}
              <RightOutlined className="Right_outlined" />
              <span> {appraisalRecord?.fullname || "-"}</span>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-between">
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <div className="px-2 d-flex">
                  <span>Performance Contract - </span>
                  <h5 className="px-2">
                    {" "}
                    {!appraisalDetails?.contractid
                      ? "Not Yet Created"
                      : appraisalDetails?.contractstatus === "created" ||
                        appraisalDetails?.contractstatus === "resend" ||
                        appraisalDetails?.contractstatus === "updated"
                        ? "Waiting for Acceptance"
                        : ["accepted", "attended", "reviewed"].includes(
                          appraisalDetails?.contractstatus
                        )
                          ? "Accepted"
                          : appraisalDetails?.contractstatus === "declined"
                            ? "Declined"
                            : appraisalDetails?.contractstatus === "attended"
                              ? "Attended"
                              : "Not Yet Created"}
                  </h5>
                </div>
              </div>
              {appraisalDetails?.contractid === appraisalRecord?.contractid &&
                (appraisalDetails?.contractstatus === "created" ||
                  appraisalDetails?.contractstatus === "resend" ||
                  appraisalDetails?.contractstatus === "updated" ||
                  appraisalDetails?.contractstatus === "declined") && (
                  <div className="d-fled align-items-center gap-2">
                    <>
                      <Editicon
                        style={{
                          backgroundColor: "#c2fae5",
                          color: "black",
                          cursor: "pointer",
                          marginRight: "10px",
                        }}
                        name="edit"
                        className="table_action_icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsAddEdit(true);
                        }}
                      />{" "}
                      {appraisalDetails?.contractstatus === "declined"
                        ? "Edit & Resend"
                        : "Edit"}
                    </>
                    <>
                      {" "}
                      <TrashDelete
                        style={{
                          backgroundColor: "#c2fae5",
                          color: "black",
                          cursor: "pointer",
                          marginRight: "10px",
                          marginLeft: "10px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          showDeleteConfirmation();
                        }}
                      />{" "}
                      Delete
                    </>
                  </div>
                )}
            </div>
            {appraisalDetails?.contractid ? (
              <>
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <p className="employee_detail_headings mb-0">
                    <b>Work Information:</b>
                  </p>
                </div>
                <Row className="employee_work_info_box">
                  {WorkInfoDetails.map((data, index) => {
                    return (
                      <Col xs={12} lg={6} key={index}>
                        <StyledRow className="my-1 employee_work_info">
                          <Col
                            sm={12}
                            md={6}
                            className={`my-1 ${data.data === "Office Competency Supervisor" ||
                              data.data === "Regional Competency Supervisor"
                              ? "text-wrap"
                              : "text-nowrap"
                              }`}
                          >
                            <b className="label_Color">{data.data}: </b>
                          </Col>
                          <Col
                            sm={12}
                            md={6}
                            className="my-1 employess_detail_values text-wrap"
                          >
                            <b className="label_value_Color">{data.value}</b>
                          </Col>
                        </StyledRow>
                      </Col>
                    );
                  })}
                </Row>
                <br />
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <p className="employee_detail_headings mb-0">
                    <b>Personal Information:</b>
                  </p>
                </div>

                <Row className="employee_work_info_box">
                  {personalDet.map((data, index) => {
                    return (
                      <Col xs={12} lg={6} key={index}>
                        <StyledRow className="my-1 employee_work_info">
                          <Col sm={12} md={6} className="my-1 text-wrap">
                            <b className="label_Color">{data.data}: </b>
                          </Col>
                          <Col
                            sm={12}
                            md={6}
                            className="my-1 employess_detail_values text-wrap"
                          >
                            <b className="label_value_Color">{data.value}</b>
                          </Col>
                        </StyledRow>
                      </Col>
                    );
                  })}
                </Row>
                <div
                  style={{
                    marginBottom:
                      appraisalDetails?.contractstatus === "declined"
                        ? "0px"
                        : "100px",
                  }}
                >
                  <div style={{ marginTop: "35px" }}>
                    <h6>{appraisalDetails?.roletype} Role</h6>
                  </div>
                  <div>
                    <p>
                      Describe specific Strategic Objectives or other
                      developmental activities to be undertaken by Appraisee
                      during the upcoming appraisal period
                    </p>
                  </div>
                  <div style={{ marginTop: "35px" }}>
                    {technicalAssessmentData?.length > 0 && (
                      <div className="table-container mb-2">
                        <h6>Strategic Objectives</h6>
                        <StyledTable
                          columns={getColumns(
                            "Strategic Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                          )}
                          dataSource={technicalAssessmentData}
                          pagination={false}
                        />
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "35px" }}>
                    {rolledOverData?.length > 0 && (
                      <div className="table-container mt-2 mb-2">
                        <div className="d-flex justify-content-between align-items-cente">
                          <h6>
                            Rollover Responsibility from Previous Appraisal
                          </h6>
                          <p
                            onClick={() => viewJobDescription()}
                            style={{
                              color: "#1890ff",
                              textDecoration: "underline",
                              fontSize: "16px",
                              cursor: "pointer",
                            }}
                          >
                            Job Description
                          </p>
                        </div>
                        <StyledTable
                          columns={getColumns(
                            "Objectives that Rolled over from Previous Appraisal Period"
                          )}
                          dataSource={rolledOverData}
                          pagination={false}
                        />
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "35px" }}>
                    {upcomingData?.length > 0 && (
                      <div className="table-container mt-2 mb-2">
                        <div className="d-flex justify-content-between align-items-cente">
                          <h6>
                            Objectives from JD for the Upcoming Appraisal Period
                          </h6>
                          <p
                            onClick={() => viewJobDescription()}
                            style={{
                              color: "#1890ff",
                              textDecoration: "underline",
                              fontSize: "16px",
                              cursor: "pointer",
                            }}
                          >
                            Job Description
                          </p>
                        </div>
                        <StyledTable
                          columns={getColumns(
                            "Target Objectives aligned to Organisational Strategy for the upcoming appraisal period"
                          )}
                          dataSource={upcomingData}
                          pagination={false}
                        />
                      </div>
                    )}
                  </div>
                  <div style={{ marginTop: "35px" }}>
                    {softSkillData?.length > 0 &&
                      appraisalDetails?.roletype === "Primary" && (
                        <div className="table-container mt-2 mb-2">
                          <h6>
                            Individual ( Soft skils ) Assessment / BDO VALUES
                          </h6>
                          <StyledTable
                            columns={dataColumns}
                            dataSource={softSkillData}
                            pagination={false}
                          />
                        </div>
                      )}
                  </div>
                </div>
                {appraisalDetails?.contractstatus === "declined" && (
                  <div style={{ marginBottom: "100px" }}>
                    <h4>Reason for Decline</h4>
                    <div
                      className="w-100 p-2 mb-5"
                      style={{
                        background: "#E4E4E4",
                        marginBottom: "50px",
                        borderRadius: "5px",
                      }}
                    >
                      {appraisalDetails?.reason}
                    </div>
                  </div>
                )}

                <img
                  src={user}
                  alt="Floating User Icon"
                  style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "50px",
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    zIndex: 1000,
                    cursor: "pointer",
                  }}
                  onClick={showModal}
                />
                <StyledCloseButton
                  style={{
                    position: "fixed",
                    bottom: "50px",
                    left: "320px",
                    borderRadius: "25px",
                    cursor: "pointer",
                    zIndex: 1000,
                    backgroundColor: "#DEEFEE !important",
                    color: "#000000 !important",
                  }}
                  onClick={() => setIsModalOpen(true)}
                >
                  {dayjs(
                    mergedHistoryData?.contractstatus === "reviewed"
                      ? mergedHistoryData?.reviewedon
                      : mergedHistoryData?.contractstatus === "attended"
                        ? mergedHistoryData?.attendedon
                        : mergedHistoryData?.accepteddeclinedon
                  ).isValid()
                    ? `${mergedHistoryData?.contractstatus === "reviewed"
                      ? "Closed on:"
                      : mergedHistoryData?.contractstatus === "attended"
                        ? "Attended on:"
                        : mergedHistoryData?.contractstatus === "accepted"
                          ? "Accepted on:"
                          : mergedHistoryData?.contractstatus === "declined"
                            ? "Declined on:"
                            : mergedHistoryData?.contractstatus === "resend"
                              ? "Resent on:"
                              : mergedHistoryData?.contractstatus === "updated"
                                ? "Updated on:"
                                : mergedHistoryData?.contractstatus === "created"
                                  ? "Created on:"
                                  : "Attended on:"
                    } ${dayjs(
                      mergedHistoryData?.contractstatus === "reviewed"
                        ? mergedHistoryData?.reviewedon
                        : mergedHistoryData?.contractstatus === "attended"
                          ? mergedHistoryData?.attendedon
                          : mergedHistoryData?.contractstatus === "accepted"
                            ? mergedHistoryData?.accepteddeclinedon
                            : mergedHistoryData?.contractstatus === "declined"
                              ? mergedHistoryData?.accepteddeclinedon
                              : mergedHistoryData?.contractstatus === "resend"
                                ? mergedHistoryData?.updatedon
                                : mergedHistoryData?.contractstatus === "updated"
                                  ? mergedHistoryData?.updatedon
                                  : mergedHistoryData?.contractstatus === "created"
                                    ? mergedHistoryData?.createdon
                                    : mergedHistoryData?.attendedon
                    )
                      .utc()
                      .tz("Africa/Nairobi")
                      .format("D MMM YYYY, hh:mm A")}`
                    : "Accepted on : -"}
                </StyledCloseButton>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 300,
                  }}
                >
                  <FolderIcon
                    style={{ width: 200, height: 200, marginBottom: 10 }}
                  />{" "}
                  <p
                    style={{ fontSize: 18, color: "#999", textAlign: "center" }}
                  >
                    {" "}
                    The Appraiser(s) haven't Created the contract yet
                  </p>
                </div>
              </>
            )}

            <AppraisalHistory
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              appraiseeid={appraisalRecord[0]?.userid}
              data={historyData?.filter(
                (item) =>
                  item.contractid === appraisalDetails?.contractid &&
                  item.contractstatus !== "draft"
              )}
              title="Contract History"
            />
          </div>
        )}
        {isAddEdit && (
          <CreateEditPerformance
            setIsAddEdit={setIsAddEdit}
            selectedUserRecord={appraisalRecord}
          />
        )}
      </Spin>
      <EmployeeInfo
        isModalVisible={isModalVisible}
        handleCancelModal={handleCancelModal}
        selectedEmployee={selectedEmployee}
      />
    </StyledDiv>
  );
};

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  .graybg {
    background-color: #f6f6f6;
  }
  .label_Color {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .label_value_Color {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
`;

export default ViewContract;
